import Vue from 'vue';
import Box from '@dbm/box';
Vue.use(Box);
Vue.prototype.$message.config({
  duration: 0,
  closable: true,
  top: 80
});
